export default {
  default: () => import("/app/ib-rewards/layouts/default.vue")
}